import './UserSwitch.sass';

import React, { FC } from 'react';
import { useDispatch } from 'react-redux';

import { Badge, List, ListItem } from '$uikit';
import { IcPlusCircle28 } from '$assets';
import { UnitName, UnitPhoto } from '$shared/components';
import { useAccounts, useCurrentUserInfo, useTranslator } from '$hooks';
import { authActions } from '$store/auth';
import { ADD_ACCOUNT } from '$shared/constants/pages';

export const UserSwitch: FC = () => {
  const accounts = useAccounts();
  const currentUser = useCurrentUserInfo();
  const dispatch = useDispatch();
  const t = useTranslator();

  const accountsWithoutCurrent = accounts
    .filter((account) => account.id !== currentUser.id)
    .sort((a, b) => a.updatesCount - b.updatesCount);

  return (
    <List className="UserSwitch">
      {accountsWithoutCurrent.length
        ? accountsWithoutCurrent.map((account) => (
            <ListItem
              className="UserSwitch__item"
              key={account.id}
              icon={
                account.updatesCount ? <Badge count={account.updatesCount} /> : undefined
              }
              onClick={() => dispatch(authActions.changeAccount(account.id))}
            >
              <div className="UserSwitch__user">
                <UnitPhoto
                  unit={account.user}
                  nftIndicator={false}
                  onlineIndicator={false}
                  size="extra-small"
                />
                <div className="UserSwitch__user__text">
                  <UnitName unit={account.user} />
                </div>
              </div>
            </ListItem>
          ))
        : undefined}
      <ListItem routeName={ADD_ACCOUNT}>
        <div className="UserSwitch__addButton">
          <div className="UserSwitch__addButton__icon">
            <IcPlusCircle28 />
          </div>
          <span>{t('user_switch_add_btn')}</span>
        </div>
      </ListItem>
    </List>
  );
};
